import React from 'react';

import { ANALYTICS_VIEW_FEATURE_LOCATIONS } from 'dpl/constants/analytics';
import AppEngagementMobileMenu from 'dpl/common/components/AppEngagementMobileMenu';

const TITLE = 'Keep up with your favorites';
const SUBTITLE =
  'Get updates on your favorite puppies and breeders in the app.';

export type FavoriteEngagementMobileMenuAnalytics = {
  view?: string;
};

export type FavoriteEngagementMobileMenuProps = {
  isOpen: boolean;
  onCloseClick: () => void;
  analytics: FavoriteEngagementMobileMenuAnalytics;
  breederFirstName?: string;
  breederProfilePhotoUrl?: string;
  variant: 'breeder' | 'puppy';
  puppyName?: string;
  puppyPhotoUrl?: string;
};

function getMessagePreviewProps({
  variant,
  breederFirstName = '',
  breederProfilePhotoUrl,
  puppyName = '',
  puppyPhotoUrl
}: Pick<
  FavoriteEngagementMobileMenuProps,
  | 'variant'
  | 'breederFirstName'
  | 'breederProfilePhotoUrl'
  | 'puppyName'
  | 'puppyPhotoUrl'
>) {
  if (variant === 'breeder') {
    return {
      title: `New litter photos from ${breederFirstName}`,
      subtitle: `See ${breederFirstName}'s latest update about their litter.`,
      coverPhotoUrl: breederProfilePhotoUrl,
      showGoodDogBadge: true as const
    };
  }

  return {
    title: `New photos of ${puppyName}`,
    subtitle: `See ${breederFirstName}'s latest update about ${puppyName}'s litter.`,
    coverPhotoUrl: breederProfilePhotoUrl,
    secondaryPhotoUrl: puppyPhotoUrl,
    showGoodDogBadge: true as const
  };
}

export default function FavoriteEngagementMobileMenu({
  isOpen,
  onCloseClick,
  analytics,
  breederFirstName,
  breederProfilePhotoUrl,
  variant,
  puppyName,
  puppyPhotoUrl
}: FavoriteEngagementMobileMenuProps) {
  const messagePreviewProps = getMessagePreviewProps({
    variant,
    breederFirstName,
    breederProfilePhotoUrl,
    puppyName,
    puppyPhotoUrl
  });

  return (
    <AppEngagementMobileMenu
      analytics={{
        view: analytics.view || '',
        view_feature_location:
          ANALYTICS_VIEW_FEATURE_LOCATIONS.POST_FAVORITE_MODAL
      }}
      title={TITLE}
      subtitle={SUBTITLE}
      isOpen={isOpen}
      onCloseClick={onCloseClick}
      messagePreviewProps={messagePreviewProps}
    />
  );
}
